import * as React from 'react'
import styled from 'styled-components/macro'
import {QUERIES} from 'common/constants'

const InstagramContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  padding: 72px 0;
  gap: 21px;
  h4 {
    font-family: 'Mulish';
    font-style: italic;
    font-weight: 500;
    font-size: calc(24 / 16 * 1rem);
    @media ${QUERIES.tabletAndUp} {
      font-size: calc(40 / 16 * 1rem);
    }
    line-height: 50px;
    color: var(--dark-grey);
    text-align: center;
  }
`

const StyledIFrame = styled.iframe`
  background: white;
  max-width: 540px;
  width: calc(100% - 2px);
  height: 440px;
  @media ${QUERIES.tabletAndUp} {
    height: 560px;
  }
  border-radius: 3px;
  border: 1px solid rgb(219, 219, 219);
  box-shadow: none;
  display: block;
  margin: 0px 0px 12px;
  min-width: 326px;
  padding: 0px;
`

const InstagramRow = () => {
  return (
    <>
      <InstagramContainer>
        <h4>Stay in Touch with Us</h4>
        <StyledIFrame
          className="instagram-media instagram-media-rendered"
          id="instagram-embed-0"
          src="https://www.instagram.com/golfinviteinc/embed/?cr=1&amp;v=14&amp;wp=1080&amp;rd=http%3A%2F%2Flocalhost%3A3000&amp;rp=%2Finsta.html#%7B%22ci%22%3A0%2C%22os%22%3A172%2C%22ls%22%3A17.600000023841858%2C%22le%22%3A170.70000004768372%7D"
          frameBorder="0"
          data-instgrm-payload-id="instagram-media-payload-0"
          scrolling="no"
        ></StyledIFrame>
      </InstagramContainer>
      <script async src="//www.instagram.com/embed.js"></script>
    </>
  )
}
export default InstagramRow
